import { CALL_API } from 'redux-api-middleware';

export const REQUEST = Symbol('REQUEST');
export const SUCCESS = Symbol('SUCCESS');
export const FAILURE = Symbol('FAILURE');

/**
* @description
* Gets the user data required for every page on the site
*
* @returns {{}}
*/
export function setup () {
    return {
        [CALL_API]: {
            endpoint: `${process.env.API_URI}/setup`,
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            },
            types: [
                REQUEST,
                SUCCESS,
                FAILURE,
            ],
        },
    };
}
